export const home = '/'
export const about = '/about'
export const jobSets = '/job-sets'
export const jobSetEditor = '/job-sets/:id(\\d+)/:edit(edit)?'
export const newJobSet = '/job-sets/new'